<template>
    <div>
        <footer>
            <div class="footer-area">
                <div class="footer-top">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-4 col-lg-4 col-md-6">
                                <div class="footer-widget">
                                    <div class="fw-logo mb-25">
                                        <router-link to="/"><img src="assets/img/logo/logo.png" alt="Apexa" /></router-link>
                                    </div>
                                    <div class="footer-content">
                                        <div class="footer-social">
                                            <ul class="list-wrap">
                                                <li><a href="https://www.facebook.com/pages/Dinas-Pendidikan-Dan-Kebudayaan-Kab-Konawe-Selatan/873686546015176/" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                                                <li><a href="https://www.instagram.com/dikbud_konsel/" target="_blank"><i class="fab fa-instagram"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Informasi</h4>
                                    <div class="footer-info-list">
                                        <ul class="list-wrap">
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-phone-call"></i>
                                                </div>
                                                <div class="content">
                                                    <a href="javascript:void(0)">+62 858-2430-7837</a>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-envelope"></i>
                                                </div>
                                                <div class="content">
                                                    <a href="mailto:dikbud@konaweselatankab.go.id">dikbud@konaweselatankab.go.id</a>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-pin"></i>
                                                </div>
                                                <div class="content">
                                                    <p>Kompleks Perkantoran Pemerintah Daerah</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Galeri Kegiatan</h4>
                                    <div class="footer-instagram">
                                        <ul class="list-wrap foto-grid">
                                            <li v-for="data in list_foto" :key="data.id" class="foto-item">
                                                <router-link to="/foto">
                                                    <img :src="file_path + data.gambar" alt="Kegiatan" />
                                                </router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-bottom">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-7 order-0 order-lg-2">
                                
                            </div>
                            <div class="col-lg-5">
                                <div class="copyright-text text-lg-end">
                                    <p>Copyright © 2024 <a href="javascript:void(0)">Dinas Pendidikan & Kebudayaan</a> | Konawe Selatan</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-shape">
                    <img class="dark-opacity" src="assets/img/images/footer_shape01.png" alt="Apexa" data-aos="fade-right" data-aos-delay="400" />
                    <img class="dark-opacity" src="assets/img/images/footer_shape02.png" alt="Apexa" data-aos="fade-left" data-aos-delay="400" />
                    <img src="assets/img/images/footer_shape03.png" alt="Apexa" data-parallax='{"x" : 100 , "y" : -100 }' />
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    data() {
        return {

            id: "",
            list_foto: [],
            unit_kerja: this.$store.state.UNIT_KERJA,

            file_path: this.$store.state.url.URL_APP + "uploads/",
            galeryku: {
                id: '',
                judul: '',
                deskripsi: '',
                file: '',
                unit_kerja: '',
                status: '',
                createBy: '',
                createAt: '',
            },
        }
    },


    methods: {
        getFoto: function () {
            fetch(this.$store.state.url.URL_FOTO + "list", {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                },
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_foto = res_data;
                    // console.log(res_data);
                });
        },

        selectDataFoto: function (data) {
            this.galeryku = {
                id: data.id,
                judul: data.judul,
                deskripsi: data.deskripsi,
                gambar: data.gambar,
                unit_kerja: data.unit_kerja,
                status: data.status,
                createBy: data.createBy,
                createAt: data.createAt,
            };
            // console.log(data);
        },
    },


    mounted() {
        this.getFoto();
    },
}
</script>

<style scoped>
.foto-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding-left: 0;
    list-style: none;
}

.foto-item img {
    width: 100%;
    height: 80px;
    object-fit: cover;
    border-radius: 6px;
    filter: grayscale(1);
    transition: filter 0.3s ease;
}

.foto-item img:hover {
    filter: grayscale(0);
}
</style>